import { gql } from "lib/apolloClient";

import {
  pageInfoFragment,
  notificationConnectionFragment,
  courseFragment,
} from "modules/CommonFragments";

export const notificationItemV2Fragment = {
  notificationItem: gql`
    fragment notificationItem on Notification {
      id
      type
      isNew
      isRead
      metadata
      category
      createdBy {
        id
        firstName
        lastName
        middleName
        profileImage
        type
        profileImage
        ... on Student {
          preferredName
          pronouns
          suffix
        }
      }
      createdAt
      updatedBy {
        id
        firstName
        lastName
        middleName
        profileImage
        ... on Student {
          preferredName
          pronouns
          suffix
        }
      }
      course {
        ...courseItem
        grades {
          id
          name
        }
        curriculumProgram {
          id
          type
        }
      }
      courses {
        id
        title
        curriculumProgram {
          id
          type
        }
      }
      updatedAt
      contextData {
        ... on Grade {
          id
          name
        }
        ... on Course {
          id
          title
          learningCourse {
            id
            title
            academicCourse {
              id
              label
            }
          }
        }
        ... on YearGroup {
          id
          name
        }
        ... on Student {
          id
          firstName
          lastName
          middleName
          type
          preferredName
          pronouns
          suffix
        }
        ... on BehaviourIncident {
          id
          uid
          category {
            id
            rootCategory {
              id
              name
            }
          }
        }
      }
      messageData
      extensionType
      extensionData
    }
    ${courseFragment.basicCourserDetails}
  `,
};

export const notificationListNodeV2Fragment = {
  staff: gql`
    fragment staffItem on Staff {
      id
      notification(
        appType: WEB
        filters: $filters
        notificationCategoryFilter: $notificationCategoryFilter
      ) {
        ...notificationConnectionItem
        edge(first: 10, after: $after) {
          cursor
          node {
            ...notificationItem
          }
        }
        pageInfo(first: 10, after: $after) {
          ...pageInfoItem
        }
      }
    }
    ${pageInfoFragment.pageInfo}
    ${notificationConnectionFragment.notificationConnection}
    ${notificationItemV2Fragment.notificationItem}
  `,
  student: gql`
    fragment studentItem on Student {
      id
      notification(
        appType: WEB
        filters: $filters
        notificationCategoryFilter: $notificationCategoryFilter
      ) {
        ...notificationConnectionItem
        edge(first: 10, after: $after) {
          cursor
          node {
            ...notificationItem
          }
        }
        pageInfo(first: 10, after: $after) {
          ...pageInfoItem
        }
      }
    }
    ${pageInfoFragment.pageInfo}
    ${notificationConnectionFragment.notificationConnection}
    ${notificationItemV2Fragment.notificationItem}
  `,
  parent: gql`
    fragment parentItem on FamilyMember {
      id
      notification(
        appType: WEB
        filters: $filters
        notificationCategoryFilter: $notificationCategoryFilter
      ) {
        ...notificationConnectionItem
        edge(first: 10, after: $after) {
          cursor
          node {
            ...notificationItem
          }
        }
        pageInfo(first: 10, after: $after) {
          ...pageInfoItem
        }
      }
    }
    ${pageInfoFragment.pageInfo}
    ${notificationConnectionFragment.notificationConnection}
    ${notificationItemV2Fragment.notificationItem}
  `,
};
